<div class="bar" [class.bar_rounded]="rounded">
  <div class="bar__progress" [style.width]="percent + '%'"></div>
</div>
